<img
  src="./assets/images/logos/incidite-head-white.svg"
  alt="Incidite"
  class="h-6 w-auto self-start" />
<h1 class="mt-5 text-2xl leading-6.5 tracking-tight text-zinc-50">
  {{ title() }}
</h1>
@if (subtitle(); as text) {
  <p class="mt-2 text-sm tracking-tight text-zinc-400">{{ text }}</p>
}
<ng-content></ng-content>
